<nz-card class="request-panel">
  <div class="page-wrapper">
    <div class="info-block">
      <div class="info-row">
        <div class="info-icon" aria-hidden="true">
          <span nz-icon nzType="notification" nzTheme="outline"></span>
        </div>
        <div class="info-text">
          <h3 class="section-title">Submit a Marketing Request</h3>
          <p class="hero-text">
            Use this form to request support for Club International marketing initiatives, including:
          </p>
          <ul class="detail-list">
            <li>Dedicated Emails</li>
            <li>Email Inclusions</li>
            <li>Event Registration</li>
            <li>OnePass Widgets, Tiles, and Push Notifications</li>
            <li>Sweepstakes</li>
            <li>Email Sign-Up Forms</li>
            <li>Other Data Collection Requests</li>
          </ul>
        </div>
      </div>

      <div class="info-row">
        <div class="info-icon" aria-hidden="true">
          <span nz-icon nzType="check-circle" nzTheme="outline"></span>
        </div>
        <div class="info-text">
          <h3 class="section-title">Before You Submit</h3>
          <p>To help us review and execute your request as efficiently as possible, please:</p>
          <ul class="detail-list detail-list--compact">
            <li>
              <strong>Review your remaining allocations</strong> for the requested marketing activity
              <a (click)="openAllocationTab()">Allocation Status</a>.
            </li>
            <li>
              <a
                href="https://nflit.sharepoint.com/:x:/r/sites/Club_International_1-1_Program/_layouts/15/Doc.aspx?sourcedoc=%7B618540D1-B296-49FE-BBFB-9F6BA760D2DD%7D&file=FE%20International%20Integrated%20Calendar%20-%20Markets%2C%20Clubs%2C%20Pillars.xlsx&action=default&mobileredirect=true&isSPOFile=1&wdExp=TEAMS-TREATMENT&web=1&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNjA4MDIwMDYyMCJ9&xsdata=MDV8MDJ8fDFkM2U4NWE2Zjc2MjQ4MDBhZTM3MDhkZjA4MWE1Yzg5fDJjZjE3YjliNDgwYTQyZjc5MTg2Y2M0ZDBmOTllMzcwfDB8MHw2MzkyMzg1ODE0MjQ1OTg1ODN8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T20xbFpYUnBibWRmV2xSQmVrMUVUWHBOUkUxMFRYcGplRmxUTURCYVIxWm9URlJzYWxwRVZYUlBSMGt5V1hwak1FOVVhR3BOVkU1clFIUm9jbVZoWkM1Mk1pOXRaWE56WVdkbGN5OHhOemc0TWpZeE16UXhOalk1fDhhODNlZTJkMDI5YjRkMzU2ZDQ0MDhkZjA4MWE1Yzg5fDIzMDA0Yjc5OGM5YTQyMWI4NGVlYjE0ZDdhMmYwNTBl&sdata=dlBRaXI0SHhNM0prelJuSXpjeElJTWUxMnE4dldZSGp1MGRvNGZTbmo2cz0%3D&ovuser=2cf17b9b-480a-42f7-9186-cc4d0f99e370%2CJagisha.Datt%40nfl.com"
                target="_blank"
                rel="noopener noreferrer"
                ><strong>Review the relevant market/country marketing calendar</strong></a
              >
              for any planned League or Club communications, as well as applicable marketing
              <a
                href="/assets/files/Intl_1to1_Creative_Specs_Best_Practices.pdf"
                target="_blank"
                rel="noopener noreferrer"
                >best practices</a
              >.
            </li>
            <li>
              <strong>Provide multiple preferred launch dates</strong> whenever possible. This gives us flexibility if
              your first-choice date is unavailable. If your request has a fixed launch date or a critical business
              dependency, please note this in the form so we can assess feasibility and required timelines.
            </li>
            <li>
              <strong>Include as much detail as possible</strong> regarding your objectives, audience, timing, creative
              requirements, and any legal or operational considerations. Providing complete information upfront helps
              expedite review and execution.
            </li>
          </ul>
        </div>
      </div>
      <div class="button-center">
        <a
          href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=m3vxLApI90KRhsxND5njcI_Nb7pHwwNNthdAv6oI6HBUN1dIMjFRSDRQUTVaVEI3M0VOVDgwV0hQUy4u"
          target="_blank"
          rel="noopener noreferrer"
          nz-button
          nzType="primary"
          nzSize="large"
          class="primary-btn"
        >
          Submit Request
        </a>
      </div>

      <div class="info-row">
        <div class="info-icon" aria-hidden="true">
          <span nz-icon nzType="profile" nzTheme="outline"></span>
        </div>
        <div class="info-text">
          <h3 class="section-title">What Happens After You Submit a Request?</h3>
          <p>Once your request is submitted:</p>
          <ul class="detail-list detail-list--steps">
            <li>The Club International team will review the request and confirm allocation availability.</li>
            <li>The request will undergo any required operational, legal, privacy, and compliance reviews.</li>
            <li>
              You will receive next steps, recommendations, or confirmation that the request has been approved for
              execution.
            </li>
          </ul>
        </div>
      </div>

      <div class="info-row">
        <div class="info-icon" aria-hidden="true">
          <span nz-icon nzType="calendar" nzTheme="outline"></span>
        </div>
        <div class="info-text">
          <h3 class="section-title">Planning &amp; Lead Times</h3>
          <p>
            Please note that turnaround times may vary based on request complexity, scope of markets involved, legal
            requirements, and available allocations.
          </p>
          <ul class="detail-list timeline-list">
            <li><strong>Standard Campaign Requests:</strong> 14 days from submission to launch</li>
            <li><strong>Creative Development:</strong> +3-10 business days</li>
            <li><strong>Legal/Privacy Review:</strong> +1-10 business days (if required)</li>
            <li><strong>Data Collection Requests:</strong> +0-10 business days</li>
            <li><strong>Custom OnePass Widgets/Tiles:</strong> +3-14 business days</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nz-card>
